import gql from "graphql-tag";

const createDocumentAgencyIssued = gql`
  mutation(
    $title: String!
    $description: String
    $address: String
    $status: String
  ) {
    createDocumentAgencyIssued(
      data: {
        title: $title
        description: $description
        address: $address
        status: $status
      }
    ) {
      id
      title
      description
      address
      status
      createdAt
      updatedAt
      author {
        id
        username
        fullname
      }
    }
  }
`;

const updateDocumentAgencyIssued = gql`
  mutation(
    $id: ID!
    $title: String!
    $description: String
    $address: String
    $status: String
  ) {
    updateDocumentAgencyIssued(
      id: $id
      data: {
        title: $title
        description: $description
        address: $address
        status: $status
      }
    ) {
      id
      title
      description
      address
      status

      updatedAt
    }
  }
`;

const deleteDocumentAgencyIssued = gql`
  mutation($id: ID!) {
    deleteDocumentAgencyIssued(id: $id) {
      id
    }
  }
`;

const getAllDocumentAgencyIssued = gql`
  query($limit: Int, $page: Int, $query: String, $status: String) {
    getAllDocumentAgencyIssued(
      query: $query
      paging: { limit: $limit, page: $page }
      filter: { status: $status }
    ) {
      id
      title
      description
      address
      status
      createdAt
      updatedAt
      author {
        id
        username
        fullname
      }
    }
  }
`;

const getDocumentAgencyIssued = gql`
  query($id: ID!) {
    getDocumentAgencyIssued(id: $id) {
      id
      title
      description
      address
      status
      createdAt
      updatedAt
      author {
        id
        username
        fullname
      }
    }
  }
`;

export default {
  createDocumentAgencyIssued,
  updateDocumentAgencyIssued,
  deleteDocumentAgencyIssued,
  getAllDocumentAgencyIssued,
  getDocumentAgencyIssued,
};
